import React, { useContext, useState } from "react";
import { BillsByCounterpartyTableContext } from "@components/bills/BillsByCounterpartyTable.context";
import { BillFilters } from "@common/contracts/bill.contract";
import { BillsByVendorView as BillsByVendorViewType } from "@common/types/views/billViews";
import { Pagination } from "@design-system/Pagination/Pagination";
import { HStack } from "@design-system/HStack/HStack";
import { CommandIsland } from "@design-system/CommandIsland/CommandIsland";
import { CommandIslandTotal } from "@design-system/CommandIsland/CommandIslandTotal";
import commandIslandStyles from "@design-system/CommandIsland/CommandIslandVariants.module.scss";
import { pluralize } from "@common/helpers/string";
import { BillsDrilldownDrawer } from "../../BillsDrilldownDrawer";
import { useBillTableEmptyView } from "../../useBillTableEmptyView";
import { defaultBillsView } from "../defaultBillViews";
import { BillsByVendorView } from "./BillsByVendorView";

interface BillsByVendorViewContainerProps {
    view: BillsByVendorViewType;
    hasConnectedBillAccounts: boolean;
    onClearFilters: () => void;
}

export const BillsByVendorViewContainer: React.FC<
    BillsByVendorViewContainerProps
> = ({ view, hasConnectedBillAccounts, onClearFilters }) => {
    const {
        data: billsByVendor = [],
        isLoading,
        currentSort,
        handleSortChange,
        totalPages,
        currentPage,
        setPage,
        counterpartiesCount,
    } = useContext(BillsByCounterpartyTableContext);

    const [drilldownParams, setDrilldownParams] = useState<BillFilters>();

    const onDrilldown = (params: BillFilters) => {
        setDrilldownParams(params);
    };

    const { emptyView, shouldHideFooter } = useBillTableEmptyView({
        isLoading,
        filteredCount: counterpartiesCount,
        hasConnectedBillAccounts,
        onClearFilters,
        viewKind: "vendors",
    });

    const footer = (
        <CommandIsland
            sticky
            className={commandIslandStyles.bulkActionsStickyFooter}
        >
            <HStack gap={8}>
                {totalPages > 1 && (
                    <Pagination
                        size="md"
                        pageCount={totalPages}
                        currentPage={currentPage}
                        onPageChange={setPage}
                    />
                )}
                <CommandIslandTotal>
                    {counterpartiesCount}{" "}
                    {pluralize("vendor", counterpartiesCount)}
                </CommandIslandTotal>
            </HStack>
        </CommandIsland>
    );

    return (
        <>
            <BillsByVendorView
                view={view}
                billsByVendor={billsByVendor}
                sort={currentSort}
                onSortChange={handleSortChange}
                onDrilldown={onDrilldown}
                footer={shouldHideFooter ? undefined : footer}
                emptyView={emptyView}
            />
            <BillsDrilldownDrawer
                view={defaultBillsView}
                open={!!drilldownParams}
                onClose={() => setDrilldownParams(undefined)}
                parentFilters={drilldownParams}
            />
        </>
    );
};
